export const getBaseImage = (base64Image : string) => {

    var splitBI = base64Image.split(',');
    var binaryString = "";
    if (splitBI.length > 1) {
        binaryString = atob(splitBI[1]);
    } else {
        binaryString = atob(splitBI[0]);
    }

    var byteArray = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
    }

    var imageSizeInBytes = byteArray.length;
    return imageSizeInBytes
};


export const toRenderImage = async (base64Image : string) => {
    let imageReduce = base64Image;
    let weight = getBaseImage(imageReduce);
    weight = weight / (1024 * 1024);
    if (weight > 0.1) {
        imageReduce = await reduceWeightImage(imageReduce);
        imageReduce = await toRenderImage(imageReduce);
    }
    return imageReduce;
}


const reduceWeightImage = async (base64Image : string) : Promise < string > => {

    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = "data:image/jpeg;base64," + base64Image;
        img.onload = function () {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d")as any;

            const newWidth = img.width / 1.5;
            const newHeight = img.height / 1.5;

            canvas.width = newWidth;
            canvas.height = newHeight;
            ctx.drawImage(img, 0, 0, newWidth, newHeight);
            const newImageDataUrl = canvas.toDataURL("image/jpeg", 0.4);
            var splitBI = newImageDataUrl.split(',');

            return resolve(splitBI[1])
        };
    })


}
